import { render, staticRenderFns } from "./Agendamento.vue?vue&type=template&id=c22ada0a"
import script from "./Agendamento.vue?vue&type=script&lang=js"
export * from "./Agendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports